<template>
    <div class="rfs:text-lg rfs:font-medium">
        <slot />
    </div>
</template>
